// extracted by mini-css-extract-plugin
module.exports = {"custom":"YellowWhiteBtn_custom__26cIb"};